let animationFrame = null;

export function smoothScrollTo(top, duration = 1050) {
    if (animationFrame !== null) {
        window.cancelAnimationFrame(animationFrame);
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollTo({top, behavior: 'auto'});
        return Promise.resolve();
    }

    const start = window.scrollY;
    const distance = top - start;

    if (Math.abs(distance) < 2) {
        return Promise.resolve();
    }

    const startedAt = window.performance.now();

    return new Promise((resolve) => {
        const step = (now) => {
            const progress = Math.min((now - startedAt) / duration, 1);
            const eased = progress < 0.5
                ? 4 * progress * progress * progress
                : 1 - Math.pow(-2 * progress + 2, 3) / 2;

            window.scrollTo(0, start + distance * eased);

            if (progress < 1) {
                animationFrame = window.requestAnimationFrame(step);
                return;
            }

            animationFrame = null;
            resolve();
        };

        animationFrame = window.requestAnimationFrame(step);
    });
}
